import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle2, Clock, Utensils, Heart } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-[#1f2e10] text-white pt-6 md:pt-12 pb-10 md:pb-16 px-4 relative overflow-hidden" data-id="element-81">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-82">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-4 md:mb-8 pt-[10px] pb-[10px]" data-id="element-83">
          Transform Your Child's Health with{' '}
          <span className="text-[#c4f000]" data-id="element-84">
            Simple, Delicious & Healthy Lunchboxes Ready in Under 15 Minutes
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap justify-center gap-2 md:gap-3 mb-5 md:mb-10" data-id="element-85">
          {[{
          icon: Clock,
          text: 'Under 15 min'
        }, {
          icon: Utensils,
          text: 'Accessible Ingredients'
        }, {
          icon: Heart,
          text: 'Nutritious & Balanced'
        }, {
          icon: CheckCircle2,
          text: 'Simple Recipes'
        }].map((feature, idx) => <div key={idx} className="flex items-center gap-1 bg-white/10 px-2 py-1 md:px-3 md:py-1.5 rounded-full text-[10px] md:text-xs font-medium border border-white/20" data-id="element-86">
              <feature.icon size={12} className="text-[#c4f000]" data-id="element-87" />
              <span data-id="element-88">{feature.text}</span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4
      }} className="relative max-w-3xl mx-auto mb-5 md:mb-10 rounded-2xl overflow-hidden shadow-2xl border-4 border-[#c4f000]/20" data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/9j32ZpkdwVdMCALtMW1mda/fbfad885-597e-463b-8365-82c90f4d6f9a.webp" alt="Before and after: unhealthy food vs healthy lunchbox ready in less than 15 minutes" className="w-full h-auto object-cover" fetchPriority="high" decoding="async" data-id="element-90" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="text-sm md:text-xl mb-4 md:mb-6 max-w-2xl mx-auto text-gray-200" data-id="element-91">
          Stop the "Lunchbox Stress" Today—Even if You’re an Overwhelmed Mom
          with Zero Time to Cook.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="flex flex-col items-center gap-1.5 mb-5 md:mb-8" data-id="element-92">
          <div className="flex items-center gap-1 text-[#c4f000]" data-id="element-93">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} size={20} fill="currentColor" data-id="element-94" />)}
          </div>
          <span className="text-sm font-medium text-gray-300" data-id="element-95">
            Excellent 4.9/5 (1,245 reviews)
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7
      }} data-id="element-96">
          <CTAButton href="#offer" data-id="element-97">
            YES! I WANT THE HAPPY LUNCHBOX SYSTEM NOW!
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}